export * from './spin-size.enum';
export * from './spin-opacity.enum';